/**
 * `/accounts/:accountId/assistants/:AssistantID/myassistant/escalations` — the
 * only place the escalation rules are mounted (`AppRouter.tsx`, the
 * `myassistant` group; the sidebar and the agent modules link there through
 * `navigation/agent-modules.ts`). Anchored at both ends, so anything nested
 * below never matches; a substring test would also catch an id that happens to
 * contain the segment.
 */
const ESCALATIONS_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/myassistant\/escalations\/?$/;

export function isEscalationsPath(pathname: string): boolean {
  return ESCALATIONS_ROUTE.test(pathname);
}
